import { Route, Routes } from 'react-router-dom';
import { ProviderDamageForm } from "../component/damageFormList/DamageFormContext";
import DamageFormDetails from "../component/damageFormList/DamageFormDetails";
import { DamageFormTable } from '../component/damageFormList/DamageFormTable';
import CreationDamageForm from '../component/damageFormList/creation/CreationDamageForm';

const DamageFormPage = () => {
    return (
        <ProviderDamageForm>
            <Routes>
                <Route path="/" element={<DamageFormTable />}/>
                <Route path="/details/:id/*" element={<DamageFormDetails />} />
				<Route path="/creation/*" element={<CreationDamageForm />} />

            </Routes>
        </ProviderDamageForm>
    );
}

export default DamageFormPage;